/* eslint-disable */
/* eslint-disable react/prop-types */
import React from 'react'
import { scaleLinear } from 'd3-scale'
import * as d3Color from 'd3-color'
import Color from '../../Utilities/Colors/ColorMap'
import Legend from '../../Legend/Legend'
import Tooltip from '../../Tooltip/Tooltip'

import setTextColorWithBackground from '../../Utilities/Colors/TextColorBasedOnBackground'

export default function Pitches({ settings, chartOptions = {} }) {
    // let pitchData = RemoveBadPitchPoints(settings.data);
    const pitchData = settings.data
    const pitcherView = chartOptions.pitcherPerspective

    const x = scaleLinear()
        .range([0, settings.vizWidth])
        .domain(pitcherView ? [4, -4] : [-4, 4])
    let y = scaleLinear().range([settings.vizHeight, 0]).domain([-1, 6])

    if (chartOptions.strikeZone === 'relative') {
        y = scaleLinear().range([settings.vizHeight, 0]).domain([-4, 4])
    }

    function handleMouseOver(event, tip) {
        Tooltip(event, settings, tip)
    }

    function handleMouseOut(event) {
        Tooltip(event, settings)
    }

    let radiusSize = 5

    if (settings.shape === 'twitter') {
        radiusSize = 4
    }

    if (chartOptions.labelPitches && pitchData.length >= 1000) {
        radiusSize = 10
    } else if (chartOptions.labelPitches && pitchData.length >= 100) {
        radiusSize = 8
    } else if (chartOptions.labelPitches && pitchData.length >= 10) {
        radiusSize = 6
    } else if (chartOptions.labelPitches && pitchData.length >= 1) {
        radiusSize = 5
    }

    return (
        <>
            <g key="pitchChart" id="pitchChart">
                {pitchData.filter(d => chartOptions.legendType === 'battedBallType' ? d.battedBallType !== null : d).map((d, i) => (
                    <g
                        key={`g_pitch_key_${i}`}
                        transform={`translate(${x(d.x)},${y(d.y)})`}
                        style={{ cursor: 'pointer' }}
                        onMouseOver={(event) => {
                            const html = d.tooltip
                            if (html) {
                                handleMouseOver(event, html)
                            }
                        }}
                        onMouseOut={(event) => {
                            handleMouseOut(event, d)
                        }}
                        onClick={() => {
                            if (d.videoUrl) {
                                window.open(d.videoUrl)
                            }
                        }}
                    >
                        <circle
                            key={`pitch_${i}`}
                            r={radiusSize / settings.vizScale}
                            opacity={chartOptions.opacity}
                            fill={Color(
                                chartOptions.legendType,
                                d[chartOptions.legendType]
                            )}
                            stroke="black"
                        />
                        {chartOptions.labelPitches ? (
                            <text
                                className="pitch-label"
                                key={`text_key_${i}`}
                                id={`text_${i}`}
                                textAnchor="middle"
                                dy={4}
                                fill={setTextColorWithBackground(
                                    d3Color.color(
                                        Color(
                                            chartOptions.legendType,
                                            d[chartOptions.legendType]
                                        )
                                    )
                                )}
                            >
                                {i + 1}
                            </text>
                        ) : null}
                    </g>
                ))}
            </g>
            {chartOptions.legend ? (
                <Legend settings={settings} type={chartOptions.legendType} />
            ) : null}
        </>
    )
}
